import { browser } from '$app/environment';
import { api } from '$lib/api';
import type { User, UserInit } from '$lib/models/user';
import { authModal } from '$lib/state/auth.svelte';
import { click } from '$lib/tracking/tool';
import type { Writable } from 'svelte/store';

class GoogleAuthResult {
  success: boolean;
  message: string;
}

let promise: Promise<GoogleAuthResult> | null = null;
let promiseResolve = (value: GoogleAuthResult) => {};
let userStoreInstance: Writable<User | null | void>;

const googleLoginListener = async (event: any) => {
  if (!browser) return;
  if (!event.data.type || event.data.type !== 'google-login') return;
  try {
    if (event.data.success) {
      const apiUser = await api<UserInit>(fetch, `/v1/userInit/`, { method: 'POST' }).then((data) => data.user);
      userStoreInstance.set(apiUser);
      authModal.hide();
      promiseResolve({ success: true, message: event.data.message });
    } else {
      promiseResolve({ success: false, message: event.data.message });
    }
  } catch (error) {
    promiseResolve({ success: false, message: 'An unexpected error occurred' });
    throw error;
  } finally {
    window.removeEventListener('message', googleLoginListener);
    promise = null;
  }
};

export function openGoogleAuth(userStore: Writable<User | null | void>): Promise<GoogleAuthResult> {
  if (!browser) {
    return Promise.resolve({ success: false, message: 'Not in a browser environment' });
  }
  userStoreInstance = userStore;
  if (!promise) {
    promise = new Promise((resolve, reject) => {
      promiseResolve = resolve;
      window.addEventListener('message', googleLoginListener);
    });
  }

  click('google_login');
  window.open('/api/v2/googleLogin', '_blank');

  return promise;
}
